var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { NotificationsService } from 'packages/notifications/NotificationsService';
import { NotificationsRepository } from 'packages/notifications/NotificationsRepository';
import { NotificationsAggregator } from 'packages/notifications/NotificationsAggregator';
import Icon from 'common/UIToolKit/Icon.vue';
import NotificationsDrawerAggregate from 'ui/v1/notifications/NotificationDrawerAggregate.vue';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
import SuccessBackground from 'components/svg/SuccessBackground.vue';
import { Cursoring } from 'packages/core/Cursoring';
import { DateUtility } from 'packages/utilities/DateUtility';
import AppLink from 'ui/v1/navigation/AppLink.vue';
import env from 'config/env.js';
import { Getter } from 'vuex-class';
var NotificationsFlyout = /** @class */ (function (_super) {
    __extends(NotificationsFlyout, _super);
    function NotificationsFlyout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationsService = new NotificationsService();
        _this.list = [];
        _this.notificationsRepo = new NotificationsRepository();
        return _this;
    }
    Object.defineProperty(NotificationsFlyout.prototype, "lastUpdateTime", {
        get: function () {
            return (new DateUtility(this.notificationsService.lastUpdateTime).format());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsFlyout.prototype, "offline", {
        get: function () {
            return !window.navigator.onLine;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsFlyout.prototype, "aggregatedList", {
        get: function () {
            return (new NotificationsAggregator()).byJobAndEvent(this.list);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsFlyout.prototype, "latestNotifications", {
        get: function () {
            return this.notificationsService.latestUnreadNotifications.items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsFlyout.prototype, "totalUnread", {
        get: function () {
            var _a;
            return this.notificationsService.latestUnreadNotifications.pagination.total
                || ((_a = this.notificationsService.latestUnreadNotifications.items) === null || _a === void 0 ? void 0 : _a.length)
                || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationsFlyout.prototype, "notificationsUrl", {
        get: function () {
            return env.APPS.NOTIFICATIONS.URL;
        },
        enumerable: false,
        configurable: true
    });
    NotificationsFlyout.prototype.mounted = function () {
        this.list = this.notificationsService.latestUnreadNotifications.items;
    };
    NotificationsFlyout.prototype.getMoreUnreadNotifications = function () {
        var _this = this;
        var cursoring = new Cursoring();
        cursoring.cursor = this.list[this.list.length - 1].id;
        this.notificationsRepo.unreadMessages(cursoring).then(function (response) {
            _this.list = _this.list.concat(response.items);
        });
    };
    NotificationsFlyout.prototype.markAllRead = function () {
        var _this = this;
        this.notificationsRepo.markAllRead().then(function () {
            _this.notificationsService.getLatestUnread().then(function () {
                _this.list = [];
            });
        });
    };
    NotificationsFlyout.prototype.onLatestNotificationsUpdated = function (items) {
        var _this = this;
        if (!this.list.length) {
            this.list = items;
            return;
        }
        var index = items.findIndex(function (item) { return item.id === _this.list[0].id; });
        if (index <= 0) {
            return;
        }
        this.list = items.slice(0, index + 1).concat(this.list);
    };
    __decorate([
        Getter,
        __metadata("design:type", Number)
    ], NotificationsFlyout.prototype, "currentCompanyId", void 0);
    __decorate([
        Watch('latestNotifications'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NotificationsFlyout.prototype, "onLatestNotificationsUpdated", null);
    NotificationsFlyout = __decorate([
        Component({
            components: {
                AppLink: AppLink,
                UiTextButton: UiTextButton,
                Icon: Icon,
                NotificationsDrawerAggregate: NotificationsDrawerAggregate,
                SuccessBackground: SuccessBackground,
            },
        })
    ], NotificationsFlyout);
    return NotificationsFlyout;
}(Vue));
export default NotificationsFlyout;
